import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGenehmigungKategorieListStatus: 'idle',
    loadGenehmigungKategorieListError: undefined as any,
    loadGenehmigungKategorieListLastParams: undefined as string | undefined,
    createGenehmigungKategorieStatus: 'idle',
    createGenehmigungKategorieError: undefined as any,
    updateGenehmigungKategorieStatus: 'idle',
    updateGenehmigungKategorieError: undefined as any,
    deleteGenehmigungKategorieStatus: 'idle',
    deleteGenehmigungKategorieError: undefined as any,

    genehmigungKategorieList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadGenehmigungKategorieList = createAsyncThunk('genehmigungKategorieSlice/loadGenehmigungKategorieList', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadGenehmigungKategorieListLastParams } = getState().genehmigungKategorieSlice
    const url = `/api/ixweb/nurisgenehmkat/`

    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadGenehmigungKategorieListLastParams && !forceReload) {
        return
    }

    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
},
{
    condition: (_, { getState }) => {
        const state = getState() as any
        const reducerStatus = state.genehmigungKategorieSlice.loadGenehmigungKategorieListStatus
        return reducerStatus !== 'preloaded'
    }
})
export const createGenehmigungKategorie = createAsyncThunk('genehmigungKategorieSlice/createGenehmigungKategorie', async (genehmigungKategorie: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmkat/`


    const reducerStatus = (getState() as any).genehmigungKategorieSlice.loadGenehmigungKategorieListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = genehmigungKategorie
    } else {
        res = await client.post(url, prepareData(genehmigungKategorie))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...genehmigungKategorie, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateGenehmigungKategorie = createAsyncThunk('genehmigungKategorieSlice/updateGenehmigungKategorie', async (genehmigungKategorie: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmkat/${genehmigungKategorie.HDR_ID}/`


    const reducerStatus = (getState() as any).genehmigungKategorieSlice.loadGenehmigungKategorieListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = genehmigungKategorie
    } else {
        res = await client.put(url, prepareData(genehmigungKategorie))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return genehmigungKategorie
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteGenehmigungKategorie = createAsyncThunk('genehmigungKategorieSlice/deleteGenehmigungKategorie', async (id: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurisgenehmkat/${id}/`


    const reducerStatus = (getState() as any).genehmigungKategorieSlice.loadGenehmigungKategorieListStatus
    let res: any = {}
    if (reducerStatus !== 'preloaded') {
        res = await client.delete(
            url,
            {
            }
        )
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const GenehmigungKategorieSlice = createSlice({
    name: 'genehmigungKategorieSlice',
    initialState,
    reducers: {
        resetloadGenehmigungKategorieListError: (state) => {
            state.loadGenehmigungKategorieListError = undefined
        },
        resetcreateGenehmigungKategorieError: (state) => {
            state.createGenehmigungKategorieError = undefined
        },
        resetupdateGenehmigungKategorieError: (state) => {
            state.updateGenehmigungKategorieError = undefined
        },
        resetdeleteGenehmigungKategorieError: (state) => {
            state.deleteGenehmigungKategorieError = undefined
        },
        removeFromGenehmigungKategorieListById: (state, action) => {
            state.genehmigungKategorieList = state.genehmigungKategorieList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.genehmigungKategorieList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGenehmigungKategorieListStatus = 'preloaded'
            state.loadGenehmigungKategorieListLastParams = ''
        },
        clearPreloadedData: (state) => {
            state.genehmigungKategorieList = []
            state.loadGenehmigungKategorieListStatus = 'idle'
            state.loadGenehmigungKategorieListLastParams = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGenehmigungKategorieList.pending, (state) => {
            state.loadGenehmigungKategorieListStatus = 'pending'
            state.loadGenehmigungKategorieListError = undefined
        })
        builder.addCase(loadGenehmigungKategorieList.fulfilled, (state, action) => {
            state.loadGenehmigungKategorieListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGenehmigungKategorieListLastParams = action.payload.params

            state.genehmigungKategorieList = action.payload.data
        })
        builder.addCase(loadGenehmigungKategorieList.rejected, (state, action) => {
            state.loadGenehmigungKategorieListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungKategorieListError = action.error.message
            } else {
                state.loadGenehmigungKategorieListError = action.payload
            }
        })

        builder.addCase(createGenehmigungKategorie.pending, (state) => {
            state.createGenehmigungKategorieStatus = 'pending'
            state.createGenehmigungKategorieError = undefined
        })
        builder.addCase(createGenehmigungKategorie.fulfilled, (state, action) => {
            state.createGenehmigungKategorieStatus = 'idle'


            state.genehmigungKategorieList = [...state.genehmigungKategorieList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
        })
        builder.addCase(createGenehmigungKategorie.rejected, (state, action) => {
            state.createGenehmigungKategorieStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createGenehmigungKategorieError = action.error.message
            } else {
                state.createGenehmigungKategorieError = action.payload
            }
        })

        builder.addCase(updateGenehmigungKategorie.pending, (state) => {
            state.updateGenehmigungKategorieStatus = 'pending'
            state.updateGenehmigungKategorieError = undefined
        })
        builder.addCase(updateGenehmigungKategorie.fulfilled, (state, action) => {
            state.updateGenehmigungKategorieStatus = 'idle'


            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.genehmigungKategorieList.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.genehmigungKategorieList.push(updatedItem) }
                else { state.genehmigungKategorieList[i] = { ...state.genehmigungKategorieList[i], ...updatedItem } }
            }
        })
        builder.addCase(updateGenehmigungKategorie.rejected, (state, action) => {
            state.updateGenehmigungKategorieStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateGenehmigungKategorieError = action.error.message
            } else {
                state.updateGenehmigungKategorieError = action.payload
            }
        })

        builder.addCase(deleteGenehmigungKategorie.pending, (state) => {
            state.deleteGenehmigungKategorieStatus = 'pending'
            state.deleteGenehmigungKategorieError = undefined
        })
        builder.addCase(deleteGenehmigungKategorie.fulfilled, (state, action) => {
            state.deleteGenehmigungKategorieStatus = 'idle'


            if (Array.isArray(action.payload)) {
                state.genehmigungKategorieList = state.genehmigungKategorieList.filter((x: any) => !action.payload.includes(x.HDR_ID))
            } else {
                state.genehmigungKategorieList = state.genehmigungKategorieList.filter((x: any) => x.HDR_ID !== action.payload)
            }
        })
        builder.addCase(deleteGenehmigungKategorie.rejected, (state, action) => {
            state.deleteGenehmigungKategorieStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGenehmigungKategorieError = action.error.message
            } else {
                state.deleteGenehmigungKategorieError = action.payload
            }
        })

    }
})

export const {
    resetloadGenehmigungKategorieListError,
    resetcreateGenehmigungKategorieError,
    resetupdateGenehmigungKategorieError,
    resetdeleteGenehmigungKategorieError,
    removeFromGenehmigungKategorieListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = GenehmigungKategorieSlice.actions
export default GenehmigungKategorieSlice.reducer
